// extracted by mini-css-extract-plugin
module.exports = {"spoiler":"Spoiler_spoiler__9scXg","control":"Spoiler_control__LMQEJ"};